import { Tooltip } from 'antd';
import React from 'react';
import { useSelector } from '../../../util/store/store';
import TrendArrow from '../TrendArrow';

interface IProps {
    value?: number
    valueClassName?: string
    layout?: 'horizontal' | 'vertical'
}

const LAYOUT_CONFIG = {
    horizontal: {
        containerClassName: 'items-center gap-[10px]',
        labelClassName: 'whitespace-nowrap text-comment',
        labelSuffix: ':',
        valueClassName: '',
        vertical: false
    },
    vertical: {
        containerClassName: 'flex-col items-center',
        labelClassName: 'whitespace-nowrap text-comment font-[400]',
        labelSuffix: '',
        valueClassName: 'justify-end leading-[22px]',
        vertical: true
    }
} as const;

const getValueConfig = (value: number, threshold?: number) => {
    if (value < 0)
        return { colorClassName: 'text-[#72A64E]', direction: 'down' as const };

    if (value === 0)
        return { colorClassName: 'text-[#72A64E]', direction: 'flat' as const };

    if (typeof threshold === 'number' && value > threshold)
        return { colorClassName: 'text-[#E95D5D]', direction: 'up' as const };

    return { colorClassName: 'text-[#627A52]', direction: 'up' as const };
};

const MortalityIncrease: React.FC<IProps> = ({ value, valueClassName, layout = 'horizontal' }) => {
    const layoutConfig = LAYOUT_CONFIG[layout];
    const isAvailable = typeof value === 'number';
    const displayValue = isAvailable ? `${Math.round(value * 100) / 100}%` : '-';
    const threshold = useSelector(state => state.login.user?.tenant.threshold_mortality_increase);
    const valueConfig = isAvailable ? getValueConfig(value, threshold) : null;

    return <div className={`flex text-[15px] ${layoutConfig.containerClassName}`}>
        <span className={layoutConfig.labelClassName}>
            Mortality increase{layoutConfig.labelSuffix}
        </span>
        <span className={[
            'whitespace-nowrap',
            layoutConfig.vertical ? 'flex items-center font-[400]' : 'inline-flex items-center font-[500]',
            valueConfig?.colorClassName || 'text-comment',
            valueClassName || '',
            layoutConfig.valueClassName
        ].join(' ')}>
            <Tooltip title='Mortality increase'>
                <span className='inline-flex w-fit items-center whitespace-nowrap'>
                    {displayValue}
                </span>
            </Tooltip>
            {valueConfig && <TrendArrow direction={valueConfig.direction} vertical={layoutConfig.vertical} />}
        </span>
    </div>;
};

export default MortalityIncrease;
